import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock, Building2, User2 } from "lucide-react";
import { cn } from "@/lib/utils";

type AppointmentCardProps = {
  appointment: {
    id: string;
    doctor_name?: string;
    date: string;
    location?: string;
    notes?: string;
    service?: {
      service_name?: string;
    };
  };
  isPast?: boolean;
};

export const AppointmentCard = ({ appointment, isPast = false }: AppointmentCardProps) => {
  const displayName = appointment.doctor_name || appointment.service?.service_name || "Non spécifié";
  
  return (
    <Card 
      className={cn(
        "hover:shadow-lg transition-all duration-300",
        isPast 
          ? "opacity-75" 
          : "hover:-translate-y-1 bg-gradient-to-br from-white to-blue-50/30"
      )}
    >
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User2 className={cn("h-5 w-5", isPast ? "" : "text-primary")} />
          <span>{displayName}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <span>
              {format(new Date(appointment.date), "PPPP", { locale: fr })}
            </span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Clock className="h-4 w-4" />
            <span>
              {format(new Date(appointment.date), "HH:mm")}
            </span>
          </div>
          {appointment.location && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Building2 className="h-4 w-4" />
              <span>{appointment.location}</span>
            </div>
          )}
          {appointment.notes && (
            <div className="mt-4 text-sm text-muted-foreground">
              {appointment.notes}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};